module.exports = __webpack_public_path__ + "static/media/california_sake.3b2ce519.webp";